import React from 'react';
import { TypographyProps, LinkProps, Typography, Link, LinkTypeMap, TypographyTypeMap } from '@mui/material';

type BreadcrumbCurrentPageProps<RootComponent extends React.ElementType = TypographyTypeMap['defaultComponent']> =
    LinkProps<
        RootComponent,
        {
            currentPage?: false;
            component?: RootComponent;
        }
    >;

type BreadcrumbLinkPageProps<RootComponent extends React.ElementType> = Omit<
    TypographyProps<
        RootComponent,
        {
            currentPage: true;
            component?: RootComponent;
        }
    >,
    'component'
>;

export type BreadcrumbProps<RootComponent extends React.ElementType> =
    | BreadcrumbCurrentPageProps<RootComponent>
    | BreadcrumbLinkPageProps<'span'>;

export function Breadcrumb<RootComponent extends React.ElementType = LinkTypeMap['defaultComponent']>({
    currentPage,
    ...props
}: BreadcrumbProps<RootComponent>) {
    if (currentPage) {
        return (
            <Typography
                component="span"
                color={(theme) => theme.palette.text.tertiary}
                aria-current="page"
                {...props}
            />
        );
    }
    return <Link underline="always" color="inherit" {...(props as BreadcrumbLinkPageProps<RootComponent>)} />;
}
